module.exports = __webpack_public_path__ + "img/home.1d94c1e4.svg";